import React from "react";
import { motion } from "framer-motion";

/**
 * Alas celestiales de ángel — line-art elegante y luminoso.
 * Plumas en abanico simétrico (geometría estática) + halo brillante.
 * Solo se anima la opacidad de los grupos para evitar que framer-motion
 * sobrescriba el transform SVG de cada pluma.
 */
const FEATHERS = [
    { angle: 46, len: 128 },
    { angle: 60, len: 134 },
    { angle: 74, len: 128 },
    { angle: 88, len: 112 },
    { angle: 101, len: 92 },
    { angle: 113, len: 70 },
    { angle: 124, len: 50 },
];

function feather(len) {
    const w = Math.max(5, len * 0.07);
    return `M0 0 C ${w} ${-len * 0.32}, ${w} ${-len * 0.7}, 0 ${-len} C ${-w} ${-len * 0.7}, ${-w} ${-len * 0.32}, 0 0 Z`;
}

export default function AngelWings({ className = "" }) {
    return (
        <svg viewBox="0 0 440 220" className={className} fill="none" aria-hidden>
            <defs>
                <linearGradient id="wingGold" x1="0" y1="1" x2="0" y2="0">
                    <stop offset="0%" stopColor="#C9A24B" stopOpacity="0.12" />
                    <stop offset="55%" stopColor="#E4CF9E" stopOpacity="0.55" />
                    <stop offset="100%" stopColor="#FBF4E2" stopOpacity="0.95" />
                </linearGradient>
                <radialGradient id="haloGlow" cx="50%" cy="50%" r="50%">
                    <stop offset="0%" stopColor="#FFFDF7" stopOpacity="1" />
                    <stop offset="45%" stopColor="#E4CF9E" stopOpacity="0.85" />
                    <stop offset="100%" stopColor="#C9A24B" stopOpacity="0" />
                </radialGradient>
            </defs>

            <motion.circle
                cx="220" cy="80" r="66" fill="url(#haloGlow)"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1.2, ease: "easeOut" }}
                style={{ transformOrigin: "220px 80px" }}
            />

            {/* Right wing */}
            <motion.g
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1.4, delay: 0.2, ease: "easeOut" }}
            >
                {FEATHERS.map((f, i) => (
                    <path
                        key={`r-${i}`}
                        d={feather(f.len)}
                        transform={`translate(232 150) rotate(${f.angle})`}
                        fill="url(#wingGold)"
                        stroke="#C9A24B"
                        strokeWidth="0.8"
                        strokeOpacity="0.5"
                    />
                ))}
            </motion.g>

            {/* Left wing */}
            <motion.g
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1.4, delay: 0.2, ease: "easeOut" }}
            >
                {FEATHERS.map((f, i) => (
                    <path
                        key={`l-${i}`}
                        d={feather(f.len)}
                        transform={`translate(208 150) rotate(${-f.angle})`}
                        fill="url(#wingGold)"
                        stroke="#C9A24B"
                        strokeWidth="0.8"
                        strokeOpacity="0.5"
                    />
                ))}
            </motion.g>

            {/* halo ring + core */}
            <motion.circle
                cx="220" cy="74" r="19"
                stroke="#C9A24B" strokeWidth="1.5" strokeOpacity="0.85"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
                style={{ transformOrigin: "220px 74px" }}
            />
            <motion.circle
                cx="220" cy="74" r="4.5" fill="#C9A24B"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.75 }}
            />
        </svg>
    );
}
